import type { NextPageContext } from 'next'
import React from 'react'
import NotFound from '../404'
import type _Infra from '../../src/mobx/Infra'
import { inject, observer } from 'mobx-react'
import Coupons from '../../src/pages/Coupons'
import type { AppParams } from 'mobx/Infra/Infra.type'
import { CACHE_POLICY } from '../../utils/constants'

const CouponsPage = ({ Infra, showPage }: { Infra?: typeof _Infra; showPage: boolean }) => {
	if (!showPage || !Infra?.appParams.features?.wallet) {
		return <NotFound />
	}

	return <Coupons />
}

export default inject('Infra', 'Home')(observer(CouponsPage))

export async function getServerSideProps(context: NextPageContext & { res: any; req: { extra: { appParams?: AppParams; nextJsError?: string } } }) {
	if (context.res && !context.req.extra.nextJsError) {
		context.res.setHeader(
			'Cache-Control',
			`public, s-maxage=${CACHE_POLICY.DEFAULT.MAX_AGE}, stale-while-revalidate=${CACHE_POLICY.DEFAULT.REVALIDATED_AGE}`
		)
	}

	const { appParams } = context.req.extra ?? {}

	return {
		props: {
			showPage: !!appParams?.features?.wallet,
		},
	}
}
